import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 2,
        mt: 'auto',
        backgroundColor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider'
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Powered by © <a href="http://www.weldingo.com" style={{ textDecoration: 'none', color: 'inherit' }}>weldinGo</a> {currentYear}
      </Typography>
    </Box>
  );
};

export default Footer;